import * as React from "react";
import { ReactComponent as Share } from "../../assets/icons/share.svg";
import { ReactComponent as Close } from "../../assets/icons/close.svg";
import { ReactComponent as Verified } from "../../assets/icons/verified.svg";
import { ReactComponent as Tiktok } from "../../assets/icons/tiktok.svg";
import { ReactComponent as Instagram } from "../../assets/icons/instagram.svg";
import { ReactComponent as Youtube } from "../../assets/icons/youtube.svg";
import { ReactComponent as Facebook } from "../../assets/icons/facebook.svg";
import { ReactComponent as X } from "../../assets/icons/x.svg";
import { ReactComponent as Discord } from "../../assets/icons/discord.svg";
import { ReactComponent as Telegram } from "../../assets/icons/telegram.svg";
import { ReactComponent as Vk } from "../../assets/icons/vk.svg";
import { ReactComponent as Email } from "../../assets/icons/email.svg";
import { ReactComponent as Whatsapp } from "../../assets/icons/whatsapp.svg";
import { ReactComponent as Link } from "../../assets/icons/link.svg";
import { ReactComponent as Globe } from "../../assets/icons/globe.svg";
import { ReactComponent as ChevronLeft } from "../../assets/icons/chevron-left.svg";
import { ReactComponent as ChevronRight } from "../../assets/icons/chevron-right.svg";
import { ReactComponent as ChevronDown } from "../../assets/icons/chevron-down.svg";
import { ReactComponent as Search } from "../../assets/icons/search.svg";
import { ReactComponent as Check } from "../../assets/icons/check.svg";
import { ReactComponent as SoundOn } from "../../assets/icons/sound-on.svg";
import { ReactComponent as SoundOff } from "../../assets/icons/sound-off.svg";
import { ReactComponent as Refresh } from "../../assets/icons/refresh.svg";
import { ReactComponent as Diamond } from "../../assets/icons/diamond.svg";
import { ReactComponent as Download } from "../../assets/icons/download.svg";
import { ReactComponent as Heart } from "../../assets/icons/heart.svg";

export type IconName =
  | 'share'
  | 'close'
  | 'verified'
  | 'tiktok'
  | 'instagram'
  | 'youtube'
  | 'facebook'
  | 'x'
  | 'discord'
  | 'telegram'
  | 'vk'
  | 'email'
  | 'whatsapp'
  | 'link'
  | 'globe'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-down'
  | 'search'
  | 'check'
  | 'sound-on'
  | 'sound-off'
  | 'refresh'
  | 'diamond'
  | 'download'
  | 'heart';

type SvgComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement>>;

const REGISTRY: Record<IconName, SvgComponent> = {
  share: Share,
  close: Close,
  verified: Verified,
  tiktok: Tiktok,
  instagram: Instagram,
  youtube: Youtube,
  facebook: Facebook,
  x: X,
  discord: Discord,
  telegram: Telegram,
  vk: Vk,
  email: Email,
  whatsapp: Whatsapp,
  link: Link,
  globe: Globe,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'chevron-down': ChevronDown,
  search: Search,
  check: Check,
  'sound-on': SoundOn,
  'sound-off': SoundOff,
  refresh: Refresh,
  diamond: Diamond,
  download: Download,
  heart: Heart,
};

interface IconProps {
  name: IconName;
  /** Optional accessible label. Omitted ⇒ decorative (aria-hidden). */
  title?: string;
}

/**
 * Inline single-glyph icon. Renders at 1em × 1em; size and color come from the
 * parent's font-size / text color (currentColor). No className/style/size props —
 * use a named usage context (parent text-[Npx]) instead.
 */
export function Icon({ name, title }: IconProps) {
  const Glyph = REGISTRY[name];
  if (!Glyph) {
    // Defensive: the IconName union already prevents this at compile time.
    // eslint-disable-next-line no-console
    console.error(`[Icon] Icon '${name}' not found in assets/icons`);
    return null;
  }
  const a11y = title
    ? { role: 'img' as const, 'aria-label': title }
    : { 'aria-hidden': true as const, focusable: false as const };
  return (
    <Glyph
      width="1em"
      height="1em"
      // verticalAlign -0.125em: standard icon optical-baseline nudge (Font
      // Awesome convention) so the glyph sits centered on the text baseline.
      style={{ display: 'inline-block', verticalAlign: '-0.125em' }}
      {...a11y}
    />
  );
}
